function suitSymbol(suit: string, white: boolean = false): string {
    if (suit === 'S') {
        return white ? '♤' : '♠'
    }
    if (suit === 'C') {
        return white ? '♧' : '♣'
    }
    if (suit === 'H') {
        return white ? '♡' : '♥'
    }
    if (suit === 'D') {
        return white ? '♢' : '♦'
    }
    return ''
}

export default suitSymbol
